// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Console from '../../lib/debug';
import KPI from './KPI';

type Props = {};

export class KPIBarClass extends Component<Props> {
    render() {
        Console.render('KPIBar');
        const { kpiData, analyticsLoading } = this.props;
        if (!kpiData || analyticsLoading) {
            return null;
        }

        return (
            <div id="kpis">
                {kpiData.map((kpiObj: {}) => {
                    return <KPI kpi={kpiObj} />;
                })}
            </div>
        );
    }
}

const mapStateToProps = (state: any, ownProps: any) => {
    return {
        ...ownProps,
        analyticsLoading: state.app.analyticsLoading,
        kpiData: state.analytics.kpi
    };
};

export default connect(mapStateToProps)(KPIBarClass);

KPIBarClass.defaultProps = {
    graphData: {}
};



// WEBPACK FOOTER //
// ./src/view/analytics/KPIBar.jsx